import { LlmContent } from "@dimensional-engineering/dimensional-models";

import styles from "./Nutshell.module.css";
import { capitalizeFirstLetter } from "@/helpers/helpers";

export default function NewProfileNutshell(props: {
  nutshellData: LlmContent[] | string | null | undefined;
}) {
  if (!props.nutshellData) {
    return <></>;
  }

  if (Array.isArray(props.nutshellData)) {
    //llmContent
    const llmContentData = props.nutshellData as LlmContent[];

    return (
      <div className={styles.llmWrapper}>
        {llmContentData.map((content, i) => {
          return (
            <div className={styles.llmbodyWrapper} key={i}>
              <h3 className={styles.llmTitle}>{content.title.toUpperCase()}</h3>
              <p className={styles.llmBody}>
                {content.paragraphs &&
                  capitalizeFirstLetter(content.paragraphs[0])}
              </p>
            </div>
          );
        })}
      </div>
    );
  } else {
    const nutshellString = props.nutshellData as string;

    return <p className={styles.llmBody}>{nutshellString}</p>;
  }
}
